import React from "react";
import {FormGroup, TextInput} from "@unibuddy/patron";

export const EditPronouns = () => (
    <FormGroup label="Pronouns">
        <TextInput name="pronouns" aria-label="Edit pronouns" maxLength={50} />
    </FormGroup>
);
